import { isEmpty } from "lodash";
import moment from "moment";
import React from "react";

export const ReceiptOrder = ({ payment, order, filials, categories, goodsList, user }) => {
    const checkPoint = () => {
        if (order.point && order.point.id) return order.point;
        if (order.point) return filials.find((item) => item.id === order.point);
        if (order.zone && order.zone.point && order.zone.point.id) return order.zone.point;
        if (order.zone && order.zone.point) return filials.find((item) => item.id === order.zone.point);
        return null;
    }

    const renderTime = () => {
        if(order.visible_datetime)
            return order.visible_datetime;
        return order.created_at
    }

    const renderWok = (good, index, isAggPrice) => {
        return (
            <>
            <tr key={index}>
                <td style={{ width: '60%', textAlign: 'start', fontSize: '1.1em', fontWeight: 'bold', padding: '3px 0' }}>{good.wokData.main.title}</td>
                <td style={{ width: '10%', textAlign: 'center', fontSize: '1.1em', fontWeight: 'bold', padding: '3px 0' }}>{good.count || 1}</td>
                <td style={{ width: '30%', textAlign: 'end', fontSize: '1.1em', fontWeight: 'bold', padding: '3px 0' }}>{((good.wokData.main.price || 0) * (good.count || 1)).toFixed(2)}</td>            
            </tr>
            {good.wokData.meat && Object.values(good.wokData.meat).map((el) =>
                <tr key={el.id + index}>
                    <td style={{ width: '60%', textAlign: 'start', fontSize: '1.1em', fontWeight: 'bold', padding: '3px 0' }}>{`+ ${el.data.title}`}</td>               
                    <td style={{ width: '10%', textAlign: 'center', fontSize: '1.1em', fontWeight: 'bold', padding: '3px 0' }}>{el.count || 1}</td>
                    <td style={{ width: '30%', textAlign: 'end', fontSize: '1.1em', fontWeight: 'bold', padding: '3px 0' }}>{((el.data.price || 0) * (el.count || 1)).toFixed(2)}</td>
                </tr>
            )}
            {good.wokData.topping && Object.values(good.wokData.topping).map((el) =>
                <tr key={el.id + index}>
                    <td style={{ width: '60%', textAlign: 'start', fontSize: '1.1em', fontWeight: 'bold', padding: '3px 0' }}>{`+ ${el.data.title}`}</td>               
                    <td style={{ width: '10%', textAlign: 'center', fontSize: '1.1em', fontWeight: 'bold', padding: '3px 0' }}>{el.count || 1}</td>
                    <td style={{ width: '30%', textAlign: 'end', fontSize: '1.1em', fontWeight: 'bold', padding: '3px 0' }}>{((el.data.price || 0) * (el.count || 1)).toFixed(2)}</td>
                </tr>
            )}
            {good.wokData.souce && Object.values(good.wokData.souce).map((el) =>
                <tr key={el.id + index}>
                    <td style={{ width: '60%', textAlign: 'start', fontSize: '1.1em', fontWeight: 'bold', padding: '3px 0' }}>{`+ ${el.title}`}</td>               
                    <td style={{ width: '10%', textAlign: 'center', fontSize: '1.1em', fontWeight: 'bold', padding: '3px 0' }}>{el.count || 1}</td>
                    <td style={{ width: '30%', textAlign: 'end', fontSize: '1.1em', fontWeight: 'bold', padding: '3px 0' }}>{((el.price || 0) * (el.count || 1)).toFixed(2)}</td>                    
                </tr>
            )}
            </>
        );
    }

    const renderGoodTitle = (good) => {
            const entityGood = goodsList.find((g) => parseInt(g.id) === parseInt(good.id));
    
            let name = '';
            if (entityGood && !isEmpty(entityGood.equipment) && entityGood.equipment.souce) name += `${entityGood.equipment.souce}.`
    
            if (good.categoryName) {
                if (good.categoryName.toLowerCase() === 'пицца') {
                    name += `${good.data.title} ${good.isMod ? '36 см' : '30 см' }`
                    return name;
                }
                name += good.data.title
                return name;
            }
            const category = categories.find(o => o.id === good.category);
            if (!category) return good.data.title;
            if (category.title.toLowerCase() === 'пицца') {
                name += `${good.data.title} ${good.isMod ? '36 см' : '30 см' }`;
                return name;
            }
            name += good.data.title
            return name;
        }

    const renderGoods = (good, index, isAggPrice) => {
        if (good.isWok) return renderWok(good, index, isAggPrice);

        return (
            <tr key={index} style={{ marginBottom: '80px'}}>
                <td style={{ width: '60%', textAlign: 'start', fontSize: '1.1em', fontWeight: 'bold', padding: '3px 0' }}>{renderGoodTitle(good)}</td>
                <td style={{ width: '10%', textAlign: 'center', fontSize: '1.1em', fontWeight: 'bold', padding: '3px 0' }}>{good.count || 1}</td>
                <td style={{ width: '30%', textAlign: 'end', fontSize: '1.1em', fontWeight: 'bold', padding: '3px 0' }}>{(((isAggPrice && good.oldPrice != null) ? good.oldPrice : (good.price || 0)) * (good.count || 1)).toFixed(2)}</td>                  
            </tr>
        );  
    }

    const point = checkPoint();

    return (
        <div className="receipt" style={{ width: '300px' }}>
            <div style={{ borderTop: '3px solid black', borderBottom: '3px solid black', display: 'flex', justifyContent: 'center' }}>
                <h1 style={{ margin: '0px' }}> 
                    SUSHIBOX 
                </h1>
            </div>
            
            <div style={{ borderBottom: '1px dashed black', padding: '5px 10px', display: 'flex', justifyContent: 'flex-start', alignItems: 'center', flexDirection: 'column' }}>
                {point && point.legalName ? <span>{`ИП ${point.legalName}`}</span> : ''}
                {point && point.inn ? <span>{`ИНН ${point.inn}`}</span> : ''}
                {point && point.ogrnip ? <span>{`ОГРНИП ${point.ogrnip}`}</span> : ''}
            </div>
            <div style={{ padding: '5px 10px', display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', flexDirection: 'column' }}>
                <span>{moment(renderTime()).format('DD.MM.YYYY HH:mm')}</span>
                <span>{`## ${order.id}`}</span>
                <span>Сотрудник {user.name || ''}</span>
            </div>
            <div style={{ padding: '5px 10px', display: 'flex', justifyContent: 'flex-start' }}>
                <table style={{ borderCollapse: 'collapse' }}>
                    <tr style={{ fontWeight: 600, borderBottom: '1px solid black' }}>
                        <td style={{ width: '60%', textAlign: 'start' }}>Наименование</td>
                        <td style={{ width: '10%', textAlign: 'center' }}>Кол.</td>
                        <td style={{ width: '30%', textAlign: 'end' }}>Сумма</td>
                    </tr>
                    {order.goods.map((good, index) => renderGoods(good, index, order.isAggPrice))}
                    <tr style={{ borderTop: '1px solid black' }}>
                        <td style={{ width: '60%', textAlign: 'start' }}>ИТОГО</td>
                        <td style={{ width: '10%' }}></td>
                        <td style={{ width: '30%', textAlign: 'end' }}>{(+order.goodsPrice).toFixed(2)}</td>
                    </tr>
                    {order.deliveryPrice != null &&
                    <tr>
                        <td style={{ width: '60%', textAlign: 'start' }}>Доставка</td>
                        <td style={{ width: '10%' }}></td>
                        <td style={{ width: '30%', textAlign: 'end' }}>{parseFloat(order.deliveryPrice).toFixed(2)}</td>
                    </tr>
                    }
                    {(+order.goodsPrice + +order.deliveryPrice) !== +order.totalPrice && <tr>
                        <td style={{ width: '60%', textAlign: 'start' }}>Скидка</td>
                        <td style={{ width: '10%' }}></td>
                        <td style={{ width: '30%', textAlign: 'end' }}>{((+order.goodsPrice + +order.deliveryPrice)- order.totalPrice).toFixed(2)}</td>
                    </tr>}
                    <tr style={{ fontWeight: 600, borderTop: '1px solid black' }}>
                        <td style={{ width: '60%', textAlign: 'start' }}>К ОПЛАТЕ</td>
                        <td style={{ width: '10%', textAlign: 'center' }}></td>
                        <td style={{ width: '30%', textAlign: 'end' }}>{(+order.totalPrice).toFixed(2)}</td>
                    </tr>
                </table>                
            </div>
            <table>
                <tr>
                    <td style={{ width: '40%', verticalAlign: 'top' }}>
                        Персон
                    </td>
                    <td style={{ width: '60%', fontWeight: 600 }}>
                        {order.unit || 0}
                    </td>
                </tr>
                <tr>
                    <td style={{ width: '40%', verticalAlign: 'top' }}>
                        Тип
                    </td>
                    <td style={{ width: '60%', fontWeight: 600 }}>
                        {order.deliveryMethod === 'own' ? 'Вынос' : 'Доставка'}
                    </td>
                </tr>
                <tr>
                    <td style={{ width: '40%', verticalAlign: 'top' }}>
                        Оплата
                    </td>
                    <td style={{ width: '60%', fontWeight: 600 }}>
                        {payment}
                    </td>
                </tr>
                {order.userName && <tr>
                    <td style={{ width: '40%', verticalAlign: 'top' }}>
                        Клиент
                    </td>
                    <td style={{ width: '60%', fontWeight: 600 }}>
                        {order.userName}
                    </td>
                </tr>}
                <tr>
                    <td style={{ width: '40%', verticalAlign: 'top' }}>
                        Улица
                    </td>
                    <td style={{ width: '60%', fontWeight: 600 }}>
                        {(order.deliveryMethod === 'delivery' && order.street) ? `${order.area ? order.area + ', ' : ''}${order.street}` : (point && point.street) ? point.street : '---'}
                    </td>
                </tr>
                <tr>
                    <td style={{ width: '40%', verticalAlign: 'top' }}>
                        Дом
                    </td>
                    <td style={{ width: '60%', fontWeight: 600 }}>
                        {(order.deliveryMethod === 'delivery' && order.house) ? order.house : (point && point.house) ? point.house : '---'}
                    </td>
                </tr>
                {order.deliveryMethod === 'delivery' && order.entrance && <tr>
                    <td style={{ width: '40%', verticalAlign: 'top' }}>
                        Подъезд
                    </td>
                    <td style={{ width: '60%', fontWeight: 600 }}>
                        {order.entrance}
                    </td>
                </tr>}
                {order.deliveryMethod === 'delivery' && order.floor && <tr>
                    <td style={{ width: '40%', verticalAlign: 'top' }}>
                        Этаж
                    </td>
                    <td style={{ width: '60%', fontWeight: 600 }}>
                        {order.floor}
                    </td>
                </tr>}
                {order.deliveryMethod === 'delivery' && order.room && <tr>
                    <td style={{ width: '40%', verticalAlign: 'top' }}>
                        Кв. (офис)
                    </td>
                    <td style={{ width: '60%', fontWeight: 600 }}>
                        {order.room}
                    </td>
                </tr>}
                {order.phone && <tr>
                    <td style={{ width: '40%', verticalAlign: 'top' }}>
                        Телефон
                    </td>
                    <td style={{ width: '60%', fontWeight: 600 }}>
                        {order.phone}
                    </td>
                </tr>}
                <tr>
                    <td style={{ width: '40%', verticalAlign: 'top' }}>
                        Примечание
                    </td>
                    <td style={{ width: '60%', fontWeight: 600 }}>
                        {order.internalComment && order.internalComment !== 'null' ? order.internalComment : '---'}
                    </td>
                </tr>
            </table>
        </div>
    );
}